import { render } from "./SelectMenu.vue?vue&type=template&id=0051ae5e"
import script from "./SelectMenu.vue?vue&type=script&lang=js"
export * from "./SelectMenu.vue?vue&type=script&lang=js"

import "./SelectMenu.vue?vue&type=style&index=0&id=0051ae5e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__